import en from './en.json';
import de from './de.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';

export default { en, de, fr, it, nl };
